import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom"; // pour rendre les routes enfants
import { TiHome } from "react-icons/ti";
import { BsFileText, BsCardChecklist } from "react-icons/bs";
import SidebarCompta from "../components/SidebarCompta";

const EspaceComptable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 840);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 840);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const shortcuts = [
    { label: "Dashboard", icon: TiHome, path: "/EspaceCompta" },
    { label: "Devis", icon: BsFileText, path: "/EspaceCompta/devis" },
    { label: "Factures", icon: BsCardChecklist, path: "/EspaceCompta/factures" },
    { label: "Clients", icon: BsCardChecklist, path: "/EspaceCompta/clients" },
  ];
  const handleClick = (path) => {
    navigate(path);
  };
  const isActive = (path) => location.pathname === path;

  return (
    <div className="lg:grid lg:grid-cols-[210px_1fr] w-full h-screen overflow-hidden">
      {/* Sidebar pour desktop */}
      {!isMobile && (
        <div className="h-screen w-60 z-20">
          <SidebarCompta />
        </div>
      )}

      {/* Main Content */}
      <div className="flex flex-col h-screen overflow-hidden w-full">
        <div className="flex-1 overflow-auto lg:px-5 py-5 bg-white shadow-lg">
          <Outlet />
        </div>

        {/* Bottom Bar pour mobile */}
        {isMobile && (
          <div className="fixed bottom-0 left-0 w-full bg-color1 border-t border-gray-300 shadow-inner flex justify-around py-2 z-50">
            {shortcuts.map((item) => (
              <button
                key={item.label}
                onClick={() => handleClick(item.path)}
                className={`flex flex-col items-center text-xs ${isActive(item.path) ? "text-color3" : "text-color2"
                  }`}
              >
                <item.icon size={24} />
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EspaceComptable;
